<ph-stack [formGroup]="formatForm">
    <ph-card heading="Optional printed check fields" flat>
        <ph-toolbar>
            <ph-field inline>
                <ph-checkbox formControlName="displayBankAccount" ngDefaultControl aria-label="Bank account"></ph-checkbox>
                <ph-label>Bank account</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayPayor" ngDefaultControl aria-label="Name and address"></ph-checkbox>
                <ph-label>Name and address</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayCheckNumber" ngDefaultControl aria-label="Check number"></ph-checkbox>
                <ph-label>Check number</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayMemo" ngDefaultControl aria-label="Memo and signature"></ph-checkbox>
                <ph-label>Memo and signature</ph-label>
            </ph-field>
            <ph-field inline>
                <ph-checkbox formControlName="displayVendorAddress" ngDefaultControl aria-label="Vendor address"></ph-checkbox>
                <ph-label>Vendor address</ph-label>
            </ph-field>
        </ph-toolbar>
    </ph-card>

    <ph-card heading="Printed check format" flat>
        <ph-columns min="200px">
            <ph-stack gap="tight" *ngFor="let option of formatOptions; trackBy: trackByValue">
                <ph-radio-group [attr.aria-label]="'Printed check format: ' + option.label"
                                [items]="[option]"
                                [value]="formatForm.controls.format.value"
                                (ph-change)="formatForm.controls.format.setValue($event.detail)"></ph-radio-group>
                <img [src]="option.image" class="img-fluid" [alt]="option.label + ' check layout'" (click)="formatForm.controls.format.setValue(option.value)">
            </ph-stack>
        </ph-columns>
    </ph-card>
</ph-stack>
